import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { InventoryReportsService, PhaseChangeEvent } from 'app/modules/vehicle-inventory/services/inventory-reports.service';
import { Rest } from 'app/rest/rest_client';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';

import InventoryReport = Rest.InventoryReport

@Component({
    selector: 'reports-body',
    templateUrl: './reports-body.component.html',
    styleUrls: ['./reports-body.component.css'],
    providers: [InventoryReportsService],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ReportsBodyComponent implements OnInit {
  @Output() phaseChange = new EventEmitter<PhaseChangeEvent>();
  svgImageSafeUrl: SafeUrl;

  inventoryReports: InventoryReport[] = [];
  isDelegationUser: boolean;
  constructor(
    private inventoryReportsService: InventoryReportsService,
    protected authenticationService: AuthenticationService,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    const user = this.authenticationService.user;
    this.isDelegationUser = !this.authenticationService.isRoleGranted('INV_DELEGATIONS_ADMIN', user);
    this.inventoryReportsService.get().then(
      (reports) => {

        for(let report of reports){
          if(!this.isDelegationUser || (this.isDelegationUser && report.delegationReport)){
            this.inventoryReports.push(report);
          }
        }
        console.log('Inventory reports:', reports);
      },
      (error) => {
        console.error('Error fetching inventory reports', error);
      }
    );

      
  
    
      
  
    
  }

  onSelectPhase(report: InventoryReport): void {
    console.log('Selected report:', report.reportType);

    this.phaseChange.emit({
      phase: 2,
      reportData: report
    });
  }

}

